export default __webpack_public_path__ + "static/media/percentage-dekstop.4d72627d.png";